import "../../Components/Page/Page.css";
import "../../Pages/Investment/Investment.css";

import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

const Competition: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="Competition" />
      <SubSection isSplit={false}>
        <div className="inv-items">
          <div className="inv-item">
            <h4 className="inv-item-title">Continuing to Use Current, Less Capable Engines</h4>
            <p className="inv-item-body">
              When our technology becomes known, traditional engines will become less desirable.
              Revealing our R&D test data, proof of concept engines, academic papers, and ELF-Tech
              patents will encourage major industry players to adopt our new technology.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Other "Want-to-Be-the-Next Best Engines"</h4>
            <p className="inv-item-body">
              Liquid-Piston, Omega1, Achates, VC-Tech, D-Cycle, split-cycle designs, InnEngine,
              Alfadan, SyTech, Mazda's new 2-stroke, Toyota's 2-stroke, Renault's 2-stroke,
              DeltaHawk's 2-stroke, Porsche's 6-stroke, CV-Motion, and others tout the benefits of
              their design and claim to be the next best engine. Our E-SPEC databases incorporate
              these designs, analyze their limitations, and offer more competitive solutions.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">EVs are "False Competition"</h4>
            <p className="inv-item-body">
              It is becoming more apparent that EVs are not as sustainable as initially thought.
              ELF-Tech offers lighter weight range extender options for EVs and hybrids alike. New
              engines and fuels can and will be cleaner than 100% electric power for work.
            </p>
          </div>
        </div>
      </SubSection>
    </div>
  );
};

export default Competition;
